"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Component = _interopRequireDefault(require("../../Component"));

var _main = _interopRequireDefault(require("../templates/main"));

var _IDate = _interopRequireDefault(require("../../../common/iObjects/IDate"));

var _IPeriod = _interopRequireDefault(require("../../../common/iObjects/IPeriod"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Main =
/*#__PURE__*/
function (_View) {
  (0, _inherits2["default"])(Main, _View);

  function Main(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Main);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Main).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", _main["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setSelectedStamps", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
      var isPeriod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.isPeriod;
      _this.selectedStartStamp = null;
      _this.selectedEndStamp = null;

      if (value) {
        // make timestamps of selected date
        if (isPeriod) {
          _this.selectedStartStamp = new _IDate["default"](value.get('start').date()).getTime();
          _this.selectedEndStamp = new _IDate["default"](value.get('end').date()).getTime();
        } else {
          _this.selectedStartStamp = new _IDate["default"](value.date()).getTime();
        }
      }

      return (0, _assertThisInitialized2["default"])(_this);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setAllowedStamps", function () {
      var allowedDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.allowedDates;
      _this.allowedDatesStart = null;
      _this.allowedDatesEnd = null;

      if (allowedDates instanceof _IPeriod["default"] && allowedDates.validate()) {
        var start = new _IDate["default"](allowedDates.get('start')),
            end = new _IDate["default"](allowedDates.get('end'));
        start.set({
          date: 1,
          minutes: 0,
          hours: 0,
          seconds: 0,
          ms: 0
        });
        end.set({
          date: 1,
          minutes: 0,
          hours: 0,
          seconds: 0,
          ms: 0
        });
        _this.allowedDatesStart = start.getTime();
        _this.allowedDatesEnd = end.getTime();
      }

      return (0, _assertThisInitialized2["default"])(_this);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setDeniedStamps", function () {
      var deniedDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.deniedDates;
      _this.deniedDatesStart = null;
      _this.deniedDatesEnd = null;

      if (deniedDates instanceof _IPeriod["default"] && deniedDates.validate()) {
        var start = new _IDate["default"](deniedDates.get('start')),
            end = new _IDate["default"](deniedDates.get('end'));
        start.set({
          date: 1,
          minutes: 0,
          hours: 0,
          seconds: 0,
          ms: 0
        });
        end.set({
          date: 1,
          minutes: 0,
          hours: 0,
          seconds: 0,
          ms: 0
        });
        _this.deniedDatesStart = start.getTime();
        _this.deniedDatesEnd = end.getTime();
      }

      return (0, _assertThisInitialized2["default"])(_this);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "submit", function () {
      if (typeof _this.props.onSubmit === 'function' && _this.selectedStartStamp !== null) {
        _this.props.onSubmit(_this.value);
      }

      return (0, _assertThisInitialized2["default"])(_this);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "cancel", function () {
      if (typeof _this.props.onCancel === 'function') {
        _this.props.onCancel();
      }

      return (0, _assertThisInitialized2["default"])(_this);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isDateInPeriod", function (date) {
      if (_this.props.isPeriod) {
        date = date instanceof _IDate["default"] ? date : new _IDate["default"](date);
        var dateStamp = date.getTime();
        return dateStamp >= _this.selectedStartStamp && dateStamp <= _this.selectedEndStamp;
      } else {
        return false;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isStartOfPeriod", function (date) {
      date = date instanceof _IDate["default"] ? date : new _IDate["default"](date);
      var dateStamp = date.getTime();
      return dateStamp === _this.selectedStartStamp;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isEndOfPeriod", function (date) {
      date = date instanceof _IDate["default"] ? date : new _IDate["default"](date);
      var dateStamp = date.getTime();
      return dateStamp === _this.selectedEndStamp;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isOneDayPeriod", function () {
      return _this.selectedStartStamp === _this.selectedEndStamp;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isTodaySelected", function (date) {
      date = date instanceof _IDate["default"] ? date : new _IDate["default"](date);
      var dateStamp = date.getTime();
      return dateStamp === _this.todayDateStamp;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isForbiddenDate", function (date) {
      date = date instanceof _IDate["default"] ? date : new _IDate["default"](date);
      var dateStamp = date.getTime(),
          _this$props = _this.props,
          isPeriod = _this$props.isPeriod,
          allowedMonths = _this$props.allowedMonths,
          _this$state = _this.state,
          allowedDates = _this$state.allowedDates,
          deniedDates = _this$state.deniedDates,
          month = date.get('month'),
          dateString = date.toString('dd.mm.yyyy');
      return (// запрещенный месяц
        !isPeriod && allowedMonths && allowedMonths.length && allowedMonths.indexOf(month) < 0 || // запрещенный день календаря
        !isPeriod && allowedDates instanceof Array && allowedDates.length && allowedDates.indexOf(dateString) < 0 || // запрещенный период дат
        allowedDates instanceof _IPeriod["default"] && (_this.allowedDatesStart > dateStamp || _this.allowedDatesEnd < dateStamp) || // запрещенный день календаря (реверс)
        !isPeriod && deniedDates instanceof Array && deniedDates.length && deniedDates.indexOf(dateString) >= 0 || deniedDates instanceof _IPeriod["default"] && dateStamp >= _this.deniedDatesStart && dateStamp <= _this.deniedDatesEnd
      );
    });

    var _allowedDates = props.allowedDates,
        _deniedDates = props.deniedDates,
        layoutDate = _this._getDefaultLayoutDate();

    _this.todayDateStamp = new _IDate["default"]('today').getTime();
    _this.state = {
      value: _this.getValue(),
      layoutDate: layoutDate,
      allowedDates: typeof _allowedDates === 'string' ? new _IPeriod["default"](_allowedDates) : _allowedDates,
      deniedDates: typeof _deniedDates === 'string' ? new _IPeriod["default"](_deniedDates) : _deniedDates
    };

    _this._setSelectedStamps();

    _this._setAllowedStamps();

    _this._setDeniedStamps();

    return (0, _possibleConstructorReturn2["default"])(_this, (0, _assertThisInitialized2["default"])(_this));
  }

  (0, _createClass2["default"])(Main, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var nextState = {},
          _this$props2 = this.props,
          value = _this$props2.value,
          allowedDates = _this$props2.allowedDates,
          deniedDates = _this$props2.deniedDates;
      var update = false;

      if (value !== prevProps.value) {
        var nextValue = this.getValue(value);
        nextState.value = nextValue;

        this._setSelectedStamps(nextValue);

        update = true;
      }

      if (allowedDates !== prevProps.allowedDates) {
        nextState.allowedDates = allowedDates;

        if (typeof allowedDates === 'string') {
          nextState.allowedDates = new _IPeriod["default"](allowedDates);
        }

        this._setAllowedStamps(nextState.allowedDates);

        update = true;
      }

      if (deniedDates !== prevProps.deniedDates) {
        nextState.deniedDates = deniedDates;

        if (typeof deniedDates === 'string') {
          nextState.deniedDates = new _IPeriod["default"](deniedDates);
        }

        this._setDeniedStamps(nextState.deniedDates);

        update = true;
      }

      if (update) {
        this.setState(nextState);
      }

      return this;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.value;

      // set first day of month
      if (value) {
        value = this.props.isPeriod ? new _IPeriod["default"](value) : new _IDate["default"](value);

        if (this.props.isPeriod) {
          value.set({
            start: value.get('start').set({
              date: 1,
              minutes: 0,
              hours: 0,
              seconds: 0,
              ms: 0
            })
          });
          value.set({
            end: value.get('end').set({
              date: 1,
              minutes: 0,
              hours: 0,
              seconds: 0,
              ms: 0
            })
          });
        } else {
          value.set({
            date: 1,
            minutes: 0,
            hours: 0,
            seconds: 0,
            ms: 0
          });
        }
      }

      if (value && !value.validate()) {
        value = null;
      }

      return value;
    }
  }, {
    key: "_shift",
    value: function _shift() {
      var dir = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var shift = {},
          attr = 'year',
          _this$props3 = this.props,
          minYear = _this$props3.minYear,
          maxYear = _this$props3.maxYear,
          current = new _IDate["default"](this.state.layoutDate);
      shift[attr] = dir; // reset day to 1

      current.set({
        date: 1
      });
      var layoutDate = current.getShifted(shift);

      if (layoutDate.get('year') >= minYear && layoutDate.get('year') <= maxYear) {
        this.setState({
          layoutDate: layoutDate
        });
      }

      return this;
    }
  }, {
    key: "select",
    value: function select(date) {
      if (!date) return this;
      date = date instanceof _IDate["default"] ? date : new _IDate["default"](date);

      if (this.props.isPeriod) {
        this._selectPeriod(date);
      } else {
        this._selectDate(date);
      }
    }
  }, {
    key: "_selectDate",
    value: function _selectDate(value) {
      var _this2 = this;

      if (!this._isForbiddenDate(value)) {
        this._setSelectedStamps(value);

        this.setState({
          value: value
        }).then(function () {
          if (typeof _this2.props.onSubmit === 'function') {
            _this2.props.onSubmit(_this2.value);
          }
        });
      }
    }
  }, {
    key: "_selectPeriod",
    value: function _selectPeriod(date) {
      date.set({
        hours: 0,
        minutes: 0
      });
      var value = this.state.value;

      if (this._isForbiddenDate(date)) {
        return;
      } // период уже выбран


      if (this._selectionStart && this._selectionEnd) {
        // сбрасываем период
        value = new _IPeriod["default"](date, date);
        this._selectionStart = true;
        this._selectionEnd = false; // выбрана начальная дата
      } else if (this._selectionStart && !this._selectionEnd) {
        value = new _IPeriod["default"](value.get('start'), date);
        this._selectionEnd = true; // не выбрано ничего
      } else if (!this._selectionStart && !this._selectionEnd) {
        value = new _IPeriod["default"](date, date);
        this._selectionStart = true;
      }

      this._setSelectedStamps(value);

      this.setState({
        value: value
      });
      return this;
    }
  }, {
    key: "_getDefaultLayoutDate",
    value: function _getDefaultLayoutDate() {
      var value = this.getValue(),
          _this$props4 = this.props,
          isPeriod = _this$props4.isPeriod,
          maxYear = _this$props4.maxYear,
          minYear = _this$props4.minYear,
          today = new _IDate["default"]('today').set({
        date: 1,
        minutes: 0,
        hours: 0,
        seconds: 0,
        ms: 0
      });
      var layoutDate;
      layoutDate = value ? isPeriod ? value.get('end') : value : today;
      layoutDate = layoutDate.get('year') > maxYear || layoutDate.get('year') < minYear ? today : layoutDate;
      return layoutDate;
    }
  }, {
    key: "value",
    get: function get() {
      if (typeof this.props.stringify === 'function') {
        return this.props.stringify(this.state.value);
      } else {
        return this.state.value;
      }
    }
  }]);
  return Main;
}(_Component["default"]);

(0, _defineProperty2["default"])(Main, "defaultProps", {
  minYear: 1970,
  maxYear: 2050,
  yearChange: false,
  allowedMonths: [],
  deniedDates: [],
  allowedDates: [],
  isPeriod: false,
  value: null,
  onSubmit: null,
  onCancel: null
});
(0, _defineProperty2["default"])(Main, "propTypes", {
  /**
   * components default value
   */
  value: _propTypes["default"].string,

  /**
   * ['01.01.2015', ... '']
   */
  deniedDates: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string]),

  /**
   * ['01.01.2015', ... ''] || IPeriod || '01.02.2015-01.02.2016'
   */
  allowedDates: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string]),

  /**
   * period selection
   */
  isPeriod: _propTypes["default"].bool,

  /**
   * [01, 02, 03 ...]
   */
  allowedMonths: _propTypes["default"].array,
  minYear: _propTypes["default"].number,
  maxYear: _propTypes["default"].number,
  yearChange: _propTypes["default"].bool,
  onSubmit: _propTypes["default"].func,
  onCancel: _propTypes["default"].func,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default palette.elPrimary
     */
    background: _propTypes["default"].string,

    /**
     * @default palette.elPrimary
     */
    borderColor: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    color: _propTypes["default"].string,

    /**
     * @default 0 6px 10px 0 ${palette.elShadow}, 0 4px 10px 0 ${palette.elShadow}
     */
    boxShadow: _propTypes["default"].string,

    /**
     * @default palette.zOverlay
     */
    zIndex: _propTypes["default"].number,

    /**
     * @default palette.tsNormal
     */
    headFontSize: _propTypes["default"].string,

    /**
     * @default palette.tlNormal
     */
    headLineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default ArrowLeft
     */
    monthDecreaseIcon: _propTypes["default"].func,

    /**
     * @default ArrowRight
     */
    monthIncreaseIcon: _propTypes["default"].func,

    /**
     * @default palette.tFilled
     */
    dateColor: _propTypes["default"].string,

    /**
     * @default palette.tsSmall
     */
    dateFontSize: _propTypes["default"].string,

    /**
     * @default palette.tlSmall
     */
    dateLineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default transparent
     */
    dateBackground: _propTypes["default"].string,

    /**
     * @default palette.tActive
     */
    dateColorHover: _propTypes["default"].string,

    /**
     * @default palette.elLightest
     */
    dateBackgroundHover: _propTypes["default"].string,

    /**
     * @default palette.tInversion
     */
    dateColorActive: _propTypes["default"].string,

    /**
     * @default palette.elAccent
     */
    dateBackgroundActive: _propTypes["default"].string,

    /**
     * @default palette.tAccent
     */
    dateTodayColor: _propTypes["default"].string,

    /**
     * @default transparent
     */
    dateTodayBackground: _propTypes["default"].string,

    /**
     * @default palette.tDisabled
     */
    dateDisabledColor: _propTypes["default"].string,

    /**
     * @default transparent
     */
    dateDisabledBackground: _propTypes["default"].string,

    /**
     * @default palette.tInversion
     */
    dateSelectedColor: _propTypes["default"].string,

    /**
     * @default palette.elAccent
     */
    dateSelectedBackground: _propTypes["default"].string,

    /**
     * @default color(palette.elAccent).alpha(0.25).string()
     */
    periodBackground: _propTypes["default"].string
  })
});
(0, _defineProperty2["default"])(Main, "displayName", 'MonthPicker');
var _default = Main;
exports["default"] = _default;